<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "DownloadIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
